/*
 * @Author: ljc_625738144@qq.com
 * @Date: 2024-09-24 10:39:36
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-11-07 17:14:47
 * @Description:
 * @FilePath: \weituManger-master\src\assets\utils\config.js
 */
var baseUrl = "https://www.wisto.com.cn/vertu/";
// var uploadUrl = "/api/admin/upload";
var uploadUrl = "https://www.wisto.com.cn/vertu/admin/upload";

var imgShow = "https://www.wisto.com.cn/files"

export { baseUrl,uploadUrl,imgShow };



// WEBPACK FOOTER //
// ./src/assets/utils/config.js